require('../proposals/global-this');

require('../proposals/string-match-all');

module.exports = require('./4');